import { SvgIcon, SvgIconProps } from '@material-ui/core'
import { useMemo } from 'react'

type AddFriendIconProps = SvgIconProps & {
    withGradient?: boolean
}

type IconGradients = [
    React.ReactNode,
    {
        gradient_0: string
        gradient_1: string
        gradient_2: string
    },
]

const useIconGradients = (): IconGradients => {
    const gradient = useMemo(() => {
        return (
            <defs>
                <radialGradient
                    id="gradient_0"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(2.2939 3.65764) rotate(48.9028) scale(29.7834 85.9525)"
                >
                    <stop stopColor="#FCE640" />
                    <stop offset="0.770739" stopColor="#F49629" />
                    <stop offset="1" stopColor="#F17E22" />
                </radialGradient>
                <radialGradient
                    id="gradient_1"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(2.2939 3.65764) rotate(48.9028) scale(29.7834 85.9525)"
                >
                    <stop stopColor="#FCE640" />
                    <stop offset="0.770739" stopColor="#F49629" />
                    <stop offset="1" stopColor="#F17E22" />
                </radialGradient>
                <radialGradient
                    id="gradient_2"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(2.2939 3.65764) rotate(48.9028) scale(29.7834 85.9525)"
                >
                    <stop stopColor="#FCE640" />
                    <stop offset="0.770739" stopColor="#F49629" />
                    <stop offset="1" stopColor="#F17E22" />
                </radialGradient>
            </defs>
        )
    }, [])

    return [
        gradient,
        { gradient_0: 'url(#gradient_0)', gradient_1: 'url(#gradient_1)', gradient_2: 'url(#gradient_2)' },
    ]
}

export default function AddFriendIcon({ withGradient, ...rest }: AddFriendIconProps) {
    const [gradientsDef, colors] = useIconGradients()
    return (
        <SvgIcon viewBox="0 0 20 18" {...rest}>
            <defs>{gradientsDef}</defs>
            <path
                d="M8 0.75C5.92893 0.75 4.25 2.42893 4.25 4.5C4.25 6.57107 5.92893 8.25 8 8.25C10.0711 8.25 11.75 6.57107 11.75 4.5C11.75 2.42893 10.0711 0.75 8 0.75Z"
                fill={withGradient ? colors.gradient_0 : 'currentColor'}
            />
            <path
                d="M4 10.25C1.92893 10.25 0.25 11.9289 0.25 14V15.1883C0.25 15.9415 0.795884 16.5837 1.53927 16.7051C5.8181 17.4037 10.1819 17.4037 14.4607 16.7051C15.2041 16.5837 15.75 15.9415 15.75 15.1883V14C15.75 11.9289 14.0711 10.25 12 10.25H11.6591C11.4746 10.25 11.2913 10.2792 11.1159 10.3364L10.2504 10.6191C8.78813 11.0965 7.21187 11.0965 5.74959 10.6191L4.88407 10.3364C4.70869 10.2792 4.52536 10.25 4.34087 10.25H4Z"
                fill={withGradient ? colors.gradient_1 : 'currentColor'}
            />
            <path
                d="M16.5 3.25C16.9142 3.25 17.25 3.58579 17.25 4V5.75H19C19.4142 5.75 19.75 6.08579 19.75 6.5C19.75 6.91421 19.4142 7.25 19 7.25H17.25V9C17.25 9.41421 16.9142 9.75 16.5 9.75C16.0858 9.75 15.75 9.41421 15.75 9V7.25H14C13.5858 7.25 13.25 6.91421 13.25 6.5C13.25 6.08579 13.5858 5.75 14 5.75H15.75V4C15.75 3.58579 16.0858 3.25 16.5 3.25Z"
                fill={withGradient ? colors.gradient_2 : 'currentColor'}
            />
        </SvgIcon>
    )
}
